export default __webpack_public_path__ + "static/media/ComfortVideo01.4ebc66c1.mp4";